import { render, staticRenderFns } from "./ClusterMonitoring.vue?vue&type=template&id=f20168a0&scoped=true"
import script from "./ClusterMonitoring.vue?vue&type=script&lang=js"
export * from "./ClusterMonitoring.vue?vue&type=script&lang=js"
import style0 from "./ClusterMonitoring.vue?vue&type=style&index=0&id=f20168a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f20168a0",
  null
  
)

export default component.exports